import { type ValidationMode } from '@wix/ambassador-forms-v1-validation-result/types';
import { type FieldsInputField } from '@wix/ambassador-forms-v4-form/types';
import { type SomeJSONSchema } from 'ajv/dist/types/json-schema';

import { asRequired, isDefined } from '../../../utils/lang';
import { mapToStringSchemaProperty } from '../string-schema-property-mapper';

import {
  getValuesFromOptions,
  makeEnumValidation,
} from './array-schema-property-mapper-platformised';

export function mapStringInputFieldToSchema(
  inputField: FieldsInputField,
  validationMode: ValidationMode,
  libraryBasedPhoneFieldValidationEnabled: boolean = false,
): SomeJSONSchema & { type: 'string' } {
  const stringInput = asRequired(
    inputField.stringOptions,
    inputField,
    'stringOptions',
  );
  const stringValidation = asRequired(
    stringInput.validation,
    stringInput,
    'validation',
  );
  const optionsValues =
    getValuesFromOptions(
      isDefined(stringInput.radioGroupOptions?.customOption),
      stringInput.radioGroupOptions?.options,
    ) ||
    getValuesFromOptions(
      isDefined(stringInput.dropdownOptions?.customOption),
      stringInput.dropdownOptions?.options,
    );
  return mapToStringSchemaProperty(
    makeEnumValidation(stringValidation, optionsValues),
    validationMode,
    libraryBasedPhoneFieldValidationEnabled,
  );
}
